import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as partnerApi from '../../lib/api/partner';

const [
  LIST_PARTNER_FILES,
  LIST_PARTNER_FILES_SUCCESS,
  LIST_PARTNER_FILES_FAILURE,
] = createRequestActionTypes('partner/LIST_PARTNER_FILES');

export const listPartnerfiles = createAction(
  LIST_PARTNER_FILES,
  (fileTyp, fileAttrVal1) => ({ fileTyp, fileAttrVal1 }),
);
const listPartnerFilesSaga = createRequestSaga(
  LIST_PARTNER_FILES,
  partnerApi.getPartnerFiles,
);

const UNLOAD_FILES = 'partner/UNLOAD_FILES';
export const unloadFiles = createAction(UNLOAD_FILES);

export function* partnerFilesSaga() {
  yield takeLatest(LIST_PARTNER_FILES, listPartnerFilesSaga);
}

const initialState = {
  files: null,
  error: null,
};

const partnerFiles = handleActions(
  {
    [LIST_PARTNER_FILES_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      files: data.list.map((file) => ({
        id: file.fileUuid,
        fileUrl: file.fileUrl,
        fileTyp: file.fileTyp,
        fileAttrVal1: file.fileAttrVal1, //parterUid
        fileAttrVal2: file.fileAttrVal2,
        fileAttrVal3: file.fileAttrVal3,
        fileNm: file.fileNm,
        fileDesc: file.fileDesc,
        // crtNm: file.crtNm,
        // crtDt: file.crtDt,
      })),
      error: null,
    }),
    [LIST_PARTNER_FILES_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_FILES]: () => initialState,
  },
  initialState,
);

export default partnerFiles;
